import React, { memo } from "react";
import styles from "./showcase.module.scss";

const Showcase = ({ image = "", description = "Hi, it is a expample", className = "" }) => (
    <div className={`${styles.imageContainer} ${className}`}>
        <img src={image} alt="Coworker" />
        <span className={styles.title}> {description}</span>
    </div>
);

export default memo(Showcase);
